import { Typography } from '@material-tailwind/react';
import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { FREE_TRIAL_EXTERNAL_LINKS } from '../../constants/urlconfig';

/* 체험 전용 헤더 */
const FreeTrialHeader = () => {
  const [isReviewMenuOpen, setIsReviewMenuOpen] = useState(false);
  const closeTimerRef = useRef<ReturnType<typeof setTimeout>>();

  const handleMouseEnterReview = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
    }

    setIsReviewMenuOpen(true);
  };

  const handleMouseLeaveReview = () => {
    closeTimerRef.current = setTimeout(() => {
      setIsReviewMenuOpen(false);
    }, 150);
  };

  const openBlogReviewLink = () => {
    window.open(FREE_TRIAL_EXTERNAL_LINKS.BLOG_REVIEW, '_blank');
  };

  const openYoutubeReviewLink = () => {
    window.open(FREE_TRIAL_EXTERNAL_LINKS.YOUTUBE_REVIEW, '_blank');
  };

  const openSeminarVideoLink = () => {
    window.open(FREE_TRIAL_EXTERNAL_LINKS.SEMINAR_VIDEO, '_blank');
  };

  const openKakaoLink = () => {
    window.open(FREE_TRIAL_EXTERNAL_LINKS.KAKAO, '_blank');
  };

  return (
    <header className="border-b border-gray-100 bg-white">
      <div className="mx-auto flex h-14 max-w-[1180px] items-center justify-between px-4 md:px-6">
        <div className="flex min-w-0 items-center gap-2 md:gap-2.5">
          <Link to="/" className="shrink-0">
            <img
              src={process.env.PUBLIC_URL + '/logo.png'}
              alt="JEBS 로고"
              className="h-9 w-9 md:h-[40px] md:w-[40px]"
            />
          </Link>

          <Typography className="truncate text-[14px] font-extrabold text-gray-900 md:text-[15px]">
            잉스바 무료체험
          </Typography>
        </div>

        <nav className="flex shrink-0 items-center gap-5 text-[12px] font-semibold text-gray-700 md:text-[13px]">
          <div
            className="relative hidden md:block"
            onMouseEnter={handleMouseEnterReview}
            onMouseLeave={handleMouseLeaveReview}
          >
            <button
              type="button"
              onClick={() => setIsReviewMenuOpen((prev) => !prev)}
              className="flex items-center gap-1"
            >
              후기 보기
              <ChevronDownIcon className="h-3.5 w-3.5" />
            </button>

            {isReviewMenuOpen && (
              <div className="absolute right-0 top-full z-50 pt-1">
                <div className="w-[100px] rounded-xl border border-gray-100 bg-white p-1 shadow-lg">
                  <button
                    type="button"
                    className="w-full rounded-lg px-3 py-2.5 text-left text-[13px] font-medium text-gray-700 hover:bg-gray-50"
                    onClick={openBlogReviewLink}
                  >
                    블로그 후기
                  </button>

                  <button
                    type="button"
                    className="w-full rounded-lg px-3 py-2.5 text-left text-[13px] font-medium text-gray-700 hover:bg-gray-50"
                    onClick={openYoutubeReviewLink}
                  >
                    유튜브 후기
                  </button>
                </div>
              </div>
            )}
          </div>

          <button
            type="button"
            className="hidden md:block"
            onClick={openSeminarVideoLink}
          >
            설명회 영상
          </button>

          <button
            type="button"
            className="rounded-full bg-[#FFD928] px-3 py-2 text-[11px] font-bold text-[#493600] md:px-4 md:text-[12px]"
            onClick={openKakaoLink}
          >
            카톡 상담
          </button>
        </nav>
      </div>
    </header>
  );
};

export default FreeTrialHeader;
